import { ShepherdService } from 'angular-shepherd';
import Step from 'shepherd.js/src/types/step';
import { offset } from '@floating-ui/dom';

export function getSteps(service: ShepherdService): Step.StepOptions[] {
	function handleCompleteTour() {
		const helpCentreElement = document.querySelector('.desktop .help-items .help-centre');
		if (helpCentreElement) {
			helpCentreElement.removeEventListener('click', handleCompleteTour);
		}
		service.complete();
	}

	return [
		{
			id: 'step1',
			title: 'Open the Help Centre',
			text: ['Open the Help Centre by clicking on this icon'],
			attachTo: {
				element: '.desktop .help-items .help-centre',
				on: 'top',
			},
			beforeShowPromise: function() {
				return new Promise(function(resolve) {
					setTimeout(function() {
						window.scrollTo(0, 0);
						resolve(null);
					}, 500);
				});
			},
			modalOverlayOpeningRadius: 5,
			modalOverlayOpeningPadding: 2,
			floatingUIOptions: {
				middleware: [offset({ mainAxis: 15, crossAxis: 12 })],
			},
			highlightClass: 'highlight',
			scrollTo: {
				block: 'center',
				behavior: 'smooth',
			},
			when: {
				show: () => {
					const helpCentreElement = document.querySelector('.desktop .help-items .help-centre');
					if (helpCentreElement) {
						helpCentreElement.addEventListener('click', handleCompleteTour);
					}
				},
				hide: () => {
					const helpCentreElement = document.querySelector('.desktop .help-items .help-centre');
					if (helpCentreElement) {
						helpCentreElement.removeEventListener('click', handleCompleteTour);
					}
				},
				cancel: () => {
					const helpCentreElement = document.querySelector('.desktop .help-items .help-centre');
					if (helpCentreElement) {
						helpCentreElement.removeEventListener('click', handleCompleteTour);
					}
				},
			},
		},
	];
}
